function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.06 19.2065C29.06 19.2065 21.008 9.17969 19.424 8.93211C17.84 8.68454 2.792 22.7963 2.66 23.4153C2.55968 23.8832 2.528 37.8984 2.528 39.1363C2.528 40.3742 2.792 40.8693 4.244 40.9931C7.412 40.9931 10.316 40.9931 10.316 40.9931C10.316 40.9931 12.692 41.2407 12.428 38.7649C12.164 36.2892 10.976 25.7672 18.368 25.2721C25.76 24.7769 25.76 36.9081 25.76 36.9081C25.76 36.9081 25.232 40.6218 27.344 40.6218C29.456 40.6218 33.152 40.6218 33.152 40.6218C33.152 40.6218 35 40.1266 35 37.1557C35 34.1848 35 20.3206 35 19.5779C35 18.8351 35 17.3497 33.416 15.3691C31.832 13.3885 21.8 2 19.688 2C17.576 2 2 17.5972 2 17.5972",
  stroke: "black",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.6ca10498.svg";
export { ForwardRef as ReactComponent };